import { getEntries } from "./API";

export const getGlobal = async () => {
  // return await getEntry("60WdGTmCq8MjtKF3wq7erG");
  const entries = await getEntries("global");
  return entries.items[0];
};

export const getInfo = async () => {
  // return await getEntry("60WdGTmCq8MjtKF3wq7erG");
  const entries = await getEntries("info");
  return entries.items[0];
};

export const getProjects = async () => {
  const entries = await getEntries("projectsIndex");
  return entries.items[0].fields.projects;
};
